import { AxiosResponse } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { fetch, post } from "src/common/networks/api-helper";
import { URL_PATHS } from "src/common/networks/url-paths";
import {
  PaymentChannel,
  SelectBankModalProps,
} from "src/libraries/types/channel";
import ToastifyAdapter from "src/libraries/components/toastify/toastify.adapter";

export const ChannelAdapter = () => {
  const [loading, setLoading] = useState(false);
  const { errorFromAPI, success } = ToastifyAdapter();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [channelData, setChannelData] = useState<PaymentChannel[]>([]);
  const [listBank, setListBank] = useState<SelectBankModalProps[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItem, setTotalItem] = useState<number>(0);
  const pageSize = 4;
  const displayData = channelData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const onPageChange = (page: number) => {
    console.log(page);

    setCurrentPage(page);
  };
  useEffect(() => {
    getListChannel();
  }, []);

  const getListChannel = () => {
    setLoading(true);
    fetch(URL_PATHS.GET_LISt_CHANNEL_BY_CLIENT_ID, null, false)
      .then((res) => {
        console.log(res);

        if (res) {
          setChannelData(res?.data);
          setTotalItem(res.data.length);
          //lọc danh sách id ngân hàng để không trùng trước khi cho vào dropdown
          let uniqueArray: SelectBankModalProps[] = Array.from(
            new Map<string, SelectBankModalProps>(
              res.data.map((item: PaymentChannel) => [
                item.bank.bankAccountId,
                {
                  value: item.bank.bankAccountId,
                  label: item.bank.bankAccountId,
                },
              ])
            ).values()
          );
          setListBank(uniqueArray);
          setLoading(false);
        }
      })
      .catch((e) => {
        errorFromAPI(e.response.data.code, e.response.data.message);
        console.log("ERROR GET LIST CHANNEL", e);
      });
  };
  const createNewChannel = (data: Record<string, any>) => {
    console.log(data);

    post(URL_PATHS.ADD_PAYMENT_CHANNEL, data, false)
      .then((res) => {
        console.log(res);
        if (res) {
          success(res.data);
          getListChannel();
        }
      })
      .catch((e) => {
        errorFromAPI(e.response.data.code, e.response.data.message);
        console.log("ERROR CREATE NEW Channel", e);
      });
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = (data: Record<string, any>) => {
    console.log(data);
    const body = {
      bankAccountId: data.accountID,
      channelName: data.channelName,
    };
    createNewChannel(body);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return {
    loading,
    totalItem,
    currentPage,
    onPageChange,
    isModalVisible,
    showModal,
    handleOk,
    handleCancel,
    handleChange,
    displayData,
    listBank,
  };
};
